import React from 'react';
import { Menu } from '@wds/menu';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import { IconCaretDown, IconCheck } from '@wds/icons';
import { SearchConsumer } from '~app/pages/AppsDirectory/components/SearchContext';
import {
  SORT_BY_TYPES_POST_SEARCH,
  SORT_BY_TYPES_PRE_SEARCH,
  getLabelFromValue,
} from '~app/pages/AppsDirectory/components/SearchContext/constants';

const MenuTrigger = order => {
  return (
    <Button variant="text" color="secondary">
      <Box display="inline" mr={2}>
        {getLabelFromValue(order)}
      </Box>
      <IconCaretDown title="Open Sort" />
    </Button>
  );
};

export const AppListingSort = () => {
  return (
    <SearchConsumer>
      {({ sortBy, updateSortBy, hasSearchParams }) => {
        const sortTypes = hasSearchParams() ? SORT_BY_TYPES_POST_SEARCH : SORT_BY_TYPES_PRE_SEARCH;
        return (
          <Menu menuTrigger={MenuTrigger(sortBy)} noRules>
            {sortTypes.map(({ label, value }) => (
              <Menu.Item key={`${label}-${value}`} onClick={() => updateSortBy(value)}>
                <Box display="flex" flexJustify="space-between">
                  {label}
                  <If condition={value === sortBy}>
                    <Box display="inline">
                      <IconCheck title="selected" />
                    </Box>
                  </If>
                </Box>
              </Menu.Item>
            ))}
          </Menu>
        );
      }}
    </SearchConsumer>
  );
};

export default AppListingSort;
